export const PRESTATIONS_SEARCH_DEBOUNCE_MS = 800;
export const PRESTATIONS_SEARCH_MIN_LENGTH = 3;

export const hasEnoughSearchLength = (searchTerm) =>
  typeof searchTerm === 'string' && searchTerm.trim().length >= PRESTATIONS_SEARCH_MIN_LENGTH;

export const isIncompleteSearchTerm = (searchTerm) => {
  const trimmedSearchTerm = typeof searchTerm === 'string' ? searchTerm.trim() : '';
  return trimmedSearchTerm.length > 0 && trimmedSearchTerm.length < PRESTATIONS_SEARCH_MIN_LENGTH;
};
